import {usePage} from "@inertiajs/inertia-vue3";
import {computed} from "vue";

const permissions = computed(() => usePage().props.value?.auth?.user?.role?.permissions ?? []);
export const hasRole = (permission) => {
    return permissions.value.some((item) => item.name === permission);
}
export const hasAnyRole = (permission) => {
    return (hasRole(`Create ${permission}`) || hasRole(`Edit ${permission}`) || hasRole(`View ${permission}`));
}

export const hasRoles = (roles) => {
    let result = false;
    roles.map((role) => {
        if (!hasRole(role) && !result) {
            result = false;
        } else {
            result = true
        }
    });

    return result;
}

